import { CheckReportDownloadStatusInput } from "@/Schemas/Reports/CheckReportDownloadStatusInput";
import { CheckReportDownloadStatusOutput, CheckReportDownloadStatusOutputSchema } from "@/Schemas/Reports/CheckReportDownloadStatusOutput";
import { DownloadReportInput } from "@/Schemas/Reports/DownloadReportInput";
import { DownloadReportOutput } from "@/Schemas/Reports/DownloadReportOutput";
import { GetDataForReportRunInput } from "@/Schemas/Reports/GetDataForReportRunInput";
import { GetDataForReportRunOutput, GetDataForReportRunOutputSchema } from "@/Schemas/Reports/GetDataForReportRunOutput";
import { GetExecutedReportDataInput } from "@/Schemas/Reports/GetExecutedReportDataInput";
import { GetExecutedReportDataOutput, GetExecutedReportDataOutputSchema } from "@/Schemas/Reports/GetExecutedReportDataOutput";
import { GetExecutedReportGroupsInput } from "@/Schemas/Reports/GetExecutedReportGroupsInput";
import { GetExecutedReportGroupsOutput, GetExecutedReportGroupsOutputSchema } from "@/Schemas/Reports/GetExecutedReportGroupsOutput";
import { GetMyReportsExecutionHistoryInput } from "@/Schemas/Reports/GetMyReportsExecutionHistoryInput";
import { GetMyReportsExecutionHistoryOutput, GetMyReportsExecutionHistoryOutputSchema } from "@/Schemas/Reports/GetMyReportsExecutionHistoryOutput";
import { GetMyReportsInput } from "@/Schemas/Reports/GetMyReportsInput";
import { GetMyReportsOutput, GetMyReportsOutputSchema } from "@/Schemas/Reports/GetMyReportsOutput";
import { ScheduleReportInput } from "@/Schemas/Reports/ScheduleReportInput";
import { ScheduleReportOutput, ScheduleReportOutputSchema } from "@/Schemas/Reports/ScheduleReportOutput";
import { parseSchema } from "@/Utils/zodParser";
import axios from "@/axios";
import { AxiosRequestConfig } from "axios";
import { getQueryString, removeFalsyPropertiesFromObject } from "vig-ui-library";

const getReportUrl = (path: string) => `/api/report/${path}`;

export const getMyReports = async (input: GetMyReportsInput, config?: AxiosRequestConfig): Promise<GetMyReportsOutput> => {
    const url = getReportUrl("get-my-reports");
    const sanitizedInput = removeFalsyPropertiesFromObject(input);
    const response = await axios.post(url, sanitizedInput, config);
    return parseSchema(GetMyReportsOutputSchema, response.data);
}

export const getMyReportsExecutionHistory = async (input: GetMyReportsExecutionHistoryInput, config?: AxiosRequestConfig): Promise<GetMyReportsExecutionHistoryOutput> => {
    const url = getReportUrl("get-my-reports-execution-history");
    const sanitizedInput = removeFalsyPropertiesFromObject(input);
    const response = await axios.post(url, sanitizedInput, config);
    return parseSchema(GetMyReportsExecutionHistoryOutputSchema, response.data);
}

export const getDataForReportRun = async (input: GetDataForReportRunInput, config?: AxiosRequestConfig): Promise<GetDataForReportRunOutput> => {
    const url = getReportUrl("get-data-for-report-run");
    const sanitizedInput = removeFalsyPropertiesFromObject(input);
    const response = await axios.post(url, sanitizedInput, config);
    return parseSchema(GetDataForReportRunOutputSchema, response.data);
}

export const scheduleReport = async (input: ScheduleReportInput, config?: AxiosRequestConfig): Promise<ScheduleReportOutput> => {
    const url = getReportUrl("schedule-report");
    const response = await axios.post(url, input, config);
    return parseSchema(ScheduleReportOutputSchema, response.data);
}

// NOT SUPPORTING PERIODIC REPORTS CHECK COMMENT IN src/Components/Assemblies/RunAssembly.tsx
// export const schedulePeriodicReport = async (input: SchedulePeriodicReportInput): Promise<BaseOutput> => {
//     const response = await axios.post("/schedule-periodic-report", input);
//     return BaseOutputSchema.parse(response.data);
// }

// export const unschedulePeriodicReport = async (input: UnschedulePeriodicReportInput): Promise<BaseOutput> => {
//     const response = await axios.post("/unschedule-periodic-report", input);
//     return BaseOutputSchema.parse(response.data);
// }

export const getExecutedReportGroups = async (input: GetExecutedReportGroupsInput, config?: AxiosRequestConfig): Promise<GetExecutedReportGroupsOutput> => {
    const url = getReportUrl("get-executed-report-groups");
    const sanitizedInput = removeFalsyPropertiesFromObject(input);
    const response = await axios.post(url, sanitizedInput, config);
    return parseSchema(GetExecutedReportGroupsOutputSchema, response.data);
}

export const getExecutedReportData = async (input: GetExecutedReportDataInput, config?: AxiosRequestConfig): Promise<GetExecutedReportDataOutput> => {
    const url = getReportUrl("get-executed-report-data");
    const sanitizedInput = removeFalsyPropertiesFromObject(input);
    const response = await axios.post(url, sanitizedInput, config);
    return parseSchema(GetExecutedReportDataOutputSchema, response.data);
}

export const checkReportDownloadStatus = async (input: CheckReportDownloadStatusInput, config?: AxiosRequestConfig): Promise<CheckReportDownloadStatusOutput> => {
    const url = getReportUrl("check-report-download-status");
    const sanitizedInput = removeFalsyPropertiesFromObject(input);
    const response = await axios.post(url, sanitizedInput, config);
    return parseSchema(CheckReportDownloadStatusOutputSchema, response.data);
}

export const downloadReport = async (input: DownloadReportInput, config?: AxiosRequestConfig): Promise<DownloadReportOutput> => {
    let url = getReportUrl(`download-report`);
    url += `?${getQueryString(input)}`;
    const response = await axios.get(url, config);
    return response.data;
}